export const CONFIG = {
    ...window.mgtradition_config,
    _has_url_hash: false
};
